import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { MatSelectionListChange } from "@angular/material";
import { WorkplaceActivityDto } from "../../services/activity.service";
import { NgForm } from "@angular/forms";

@Component({
    selector: "activity-overview",
    template: require('./activity-overview.component.html'),
    styles: [require('./activity-overview.component.css')]
})
export class ActivityOverviewComponent {
    @ViewChild("activityForm")
    activityForm: NgForm;

    selectedActivities: Nema.Crew.Model.Activity[];
    selectedActivity: Nema.Crew.Model.Activity;

    _selectedWorkplace: Nema.Crew.Model.Workplace;

    @Input()
    get selectedWorkplace(): Nema.Crew.Model.Workplace {
        return this._selectedWorkplace;
    }

    set selectedWorkplace(val) {
        this._selectedWorkplace = val;
        this.selectedWorkplaceChange.emit(this.selectedWorkplace);
    }

    @Output()
    selectedWorkplaceChange = new EventEmitter<Nema.Crew.Model.Workplace>();

    _selectedWorkgroup: Nema.Crew.Model.WorkGroup;

    @Input()
    get selectedWorkgroup(): Nema.Crew.Model.WorkGroup {
        return this._selectedWorkgroup;
    }

    set selectedWorkgroup(val) {
        this._selectedWorkgroup = val;
        this.selectedWorkgroupChange.emit(this._selectedWorkgroup);
    }

    @Output()
    selectedWorkgroupChange = new EventEmitter<Nema.Crew.Model.WorkGroup>();

    wpActivities: WorkplaceActivityDto[];

    @Input()
    get workplaceActivities(): WorkplaceActivityDto[] {
        return this.wpActivities;
    }

    set workplaceActivities(val) {
        this.wpActivities = val;
        this.selectedActivities = [];
        this.selectedActivity = null;
    }

    @Input()
    workplaces: Nema.Crew.Model.Workplace[];

    @Input()
    workgroups: Nema.Crew.Model.WorkGroup[];

    @Input()
    activityTypes: Nema.Crew.Model.ActivityType[];

    @Input()
    jobTypes: Nema.Crew.Model.JobType[];

    @Input()
    isLoading = false;

    @Input()
    isFetching = false;

    @Output()
    updateActivity = new EventEmitter<Nema.Crew.Model.Activity>();

    @Output()
    deleteActivity = new EventEmitter<Nema.Crew.Model.Activity>();

    @Output()
    deleteAllActivities = new EventEmitter();

    onActivitySelectionChange(eventArgs: MatSelectionListChange) {
        eventArgs.source.deselectAll();
        this.selectedActivities = [eventArgs.option.value];
        this.selectedActivity = this.clone(eventArgs.option.value);

        if (this.activityForm) {
            this.activityForm.reset(this.selectedActivity);
        }
    }

    onUpdateActivity() {
        this.updateActivity.emit(this.selectedActivity);
    }

    onDeleteActivity() {
        this.deleteActivity.emit(this.selectedActivity);
    }

    onDeleteAllActivities() {
        this.deleteAllActivities.emit();
    }

    resetFilter() {
        this.selectedActivities = [];
        this.selectedActivity = null;
        this.selectedWorkplace = null;
        this.selectedWorkgroup = null;
    }

    resetSelectedActivity() {
        this.selectedActivities = [];
        this.selectedActivity = null;
    }

    getTotalCountText(): string {
        const registeredActivitiesCount = this.workplaceActivities
            .reduce((sum, el) => sum + el.Activities.length, 0);

        return `${registeredActivitiesCount} registered activities`;
    }

    private clone(activity: Nema.Crew.Model.Activity): Nema.Crew.Model.Activity {
        const copy: Nema.Crew.Model.Activity = Object.assign({}, activity);
        return copy;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/daily-activities/activity-overview.component.ts